import { createFileRoute } from '@tanstack/react-router';
import CustomerDetail from '@/pages/CustomerDetail';

/**
 * Customer Detail Route (/customers/:customerId)
 * 
 * Implements Requirements 6.1, 6.2, 6.3, 6.4, 6.6, 6.9:
 * - TanStack Router for type-safe routing
 * - Nested routes with layout composition
 * - Automatic code splitting per route
 * - Route data preloading before render
 * - Type-safe route parameters
 * - Suspense for loading states
 * 
 * Protected route that displays a single customer's details.
 * Inherits authentication guard from _authenticated layout.
 */

export const Route = createFileRoute('/_authenticated/customers/$customerId')({
  component: CustomerDetail,
});
